import React from 'react';
import { Helmet } from 'react-helmet';
import { useLingui } from '@lingui/react/macro';

import getBrandSiteName from '@rover/shared/js/utils/getBrandSiteName';
import getBrandSpecificValue from '@rover/shared/js/utils/getBrandSpecificValue';

type Props = {
  serviceTypeSlug: string;
  getServiceTypeName: (arg0: string) => string;
};

const HtmlHeader = ({ serviceTypeSlug, getServiceTypeName }: Props): JSX.Element => {
  const { t } = useLingui();
  const serviceType = getServiceTypeName(serviceTypeSlug);
  const brandSiteName = getBrandSiteName();
  const title = t`Search For Pet Care In Your Neighborhood | ${brandSiteName}`;
  const description = getBrandSpecificValue({
    rover: t`${serviceType} on Rover.com connects you to a nationwide network of dog lovers for hire. Because we believe everyone should experience the love of a dog.`,
    catInAFlat: t`${serviceType} on Catinaflat.com connects you to a nationwide network of cat lovers for hire. Because we believe everyone should experience the love of a cat.`,
  });

  return (
    <Helmet>
      <title>{title}</title>
      <meta property="og:title" content={title} />

      <meta name="twitter:card" content="summary" />
      <meta property="og:type" content="website" />

      <meta property="og:description" content={description} />
      <meta name="description" content={description} />
    </Helmet>
  );
};

export default HtmlHeader;
